export const FEATURE_FLAGS = {
  funds: import.meta.env.VITE_FEATURE_FUNDS === 'true',
  budgets: import.meta.env.VITE_FEATURE_BUDGETS === 'true',
  disableInlineManual: import.meta.env.VITE_DISABLE_INLINE_MANUAL === 'true',
};
